module.exports = __webpack_public_path__ + "img/20250207-01-01.35baa54c.png";